import axios from "axios";

import { BASE_URL } from "../../src/utils/api_base_url_configration";



export const getTagSetServ = async (formData) => {
  try {
    const response = await axios.post(BASE_URL + "tag/list", formData);
    return response;
  } catch (error) {
    // Handle error (e.g., log or throw an error)
    console.error("Error fetching data:", error);
    throw error;
  }
};


export const addTagServ = async (formData) => {
  try {
    const response = await axios.post(BASE_URL + "tag/create", formData);
    return response;
  } catch (error) {
    // Handle error (e.g., log or throw an error)
    console.error("Error fetching data:", error);
    throw error;
  }
};

export const updateTagServ = async (formData) => {
  try {
    const response = await axios.put(BASE_URL + "tag/update", formData);
    return response;
  } catch (error) {
    // Handle error (e.g., log or throw an error)
    console.error("Error fetching data:", error);
    throw error;
  }
};
export const deleteTagServ = async (id) => {
  try {
    const response = await axios.delete(BASE_URL + "tag/delete/"+id);
    return response;
  } catch (error) {
    // Handle error (e.g., log or throw an error)
    console.error("Error fetching data:", error);
    throw error;
  }
};
